function staticMiddleEllipsis(_ref) {
  var text = _ref.text,
    _ref$leftSideLength = _ref.leftSideLength,
    leftSideLength = _ref$leftSideLength === void 0 ? 4 : _ref$leftSideLength,
    _ref$rightSideLength = _ref.rightSideLength,
    rightSideLength = _ref$rightSideLength === void 0 ? 4 : _ref$rightSideLength;
  var isTooShort = leftSideLength + rightSideLength >= text.length;
  if (isTooShort) return text;
  var leftSide = text.substring(0, leftSideLength);
  var rightSide = text.substring(text.length - rightSideLength, text.length);
  return "".concat(leftSide, "...").concat(rightSide);
}

export { staticMiddleEllipsis };
//# sourceMappingURL=ellipsisHelpers.js.map
